import React from 'react';
import { Card } from 'react-bootstrap';
import Loader from 'shared/Loader';
import BeSafeContainer from './BeSafeContainer';

const BeSafeCard = ({ className, title, buttons, loading, children }) => {
  return (
    <Card className={`${className ? className : ''} shadow`}>
      <BeSafeContainer visible={loading}>
        <div className="p-3">
          <Loader />
        </div>
      </BeSafeContainer>
      <BeSafeContainer visible={!loading}>
        {(title || buttons) && (
          <Card.Header className="text-black d-flex justify-content-between align-items-center">
            <span>
              {title}
              {className.includes('card-field') ? ':' : ''}
            </span>
            {buttons}
          </Card.Header>
        )}
        {children && (
          <Card.Body className="pb-3 card-body">{children}</Card.Body>
        )}
      </BeSafeContainer>
    </Card>
  );
};
BeSafeCard.defaultProps = {
  className: '',
  title: null,
  buttons: null,
  loading: false,
  children: null,
};

export default BeSafeCard;
